import { FlexTypography } from "@lyfegen-platform/react-common";
import { Variant } from "@material-ui/core/styles/createTypography";
import useResizeObserver from "../../hooks/use-resize-observer";
import getTextWidth from "../../utils/get-text-width";

interface IFormattedProducts {
	rowData: any;
	fieldAssessor: string;
	variant?: Variant;
	showOnlyFirstItem?: true;
	separator?: string;
}

const FlexTypographyArray: React.FC<IFormattedProducts> = ({
	rowData,
	fieldAssessor,
	variant = "body2",
	showOnlyFirstItem,
	separator = ",",
}) => {
	const { ref, width = 1 } = useResizeObserver<HTMLDivElement>();
	const text = rowData[fieldAssessor];
	const isTooltipShown = width < getTextWidth(text) || showOnlyFirstItem;
	const fieldArr = rowData[fieldAssessor]?.split(separator);

	return (
		<div ref={ref}>
			<FlexTypography
				width={width}
				variant={variant}
				typographyProps={{ variant }}
				text={text}
				tooltipPlacement="top-start"
				renderText={(text: string) => (isTooltipShown ? `${fieldArr[0]}` : text)}
				forceTooltipRender={(showOnlyFirstItem && fieldArr.length > 1) || undefined}
				itemCounter={isTooltipShown && fieldArr.length > 1 ? `\u00A0+${fieldArr.length - 1}` : ""}
			/>
		</div>
	);
};

export default FlexTypographyArray;
